// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Patient → Clinical → Allergies only.
 *
 * Materialize is prefixed to \`.emr-mz-dashboard\`. Without these scoped
 * counters, \`td, th { padding: 15px 5px }\`, 3rem inputs, \`select { display:
 * none }\`, and hidden native checkboxes inflate the allergy table and hide
 * form controls. Do not change global Materialize or Medical History.
 */

.emr-mz-dashboard .allergies-section,
.allergies-section {
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
  box-sizing: border-box;
}

.emr-mz-dashboard .allergies-section *,
.emr-mz-dashboard .allergies-section *::before,
.emr-mz-dashboard .allergies-section *::after,
.allergies-section *,
.allergies-section *::before,
.allergies-section *::after {
  box-sizing: border-box;
}

.emr-mz-dashboard .allergies-section,
.allergies-section,
.emr-mz-dashboard .allergies-section h2,
.emr-mz-dashboard .allergies-section h3,
.emr-mz-dashboard .allergies-section p,
.emr-mz-dashboard .allergies-section li,
.emr-mz-dashboard .allergies-section label,
.emr-mz-dashboard .allergies-section span,
.emr-mz-dashboard .allergies-section button,
.allergies-section h2,
.allergies-section h3,
.allergies-section p,
.allergies-section li,
.allergies-section label,
.allergies-section span,
.allergies-section button {
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .allergies-section table.allergies-table,
.allergies-section table.allergies-table {
  display: table !important;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  position: static;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .allergies-section table.allergies-table thead,
.allergies-section table.allergies-table thead {
  display: table-header-group !important;
  float: none;
  position: static;
}

.emr-mz-dashboard .allergies-section table.allergies-table tbody,
.allergies-section table.allergies-table tbody {
  display: table-row-group !important;
  float: none;
  position: static;
}

.emr-mz-dashboard .allergies-section table.allergies-table tr,
.allergies-section table.allergies-table tr {
  display: table-row !important;
  height: 20px;
}

.emr-mz-dashboard .allergies-section table.allergies-table th,
.emr-mz-dashboard .allergies-section table.allergies-table td,
.allergies-section table.allergies-table th,
.allergies-section table.allergies-table td {
  display: table-cell !important;
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  padding: 2px 2px;
  padding-top: 2px;
  padding-bottom: 2px;
  line-height: 16px;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  vertical-align: middle;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.emr-mz-dashboard .allergies-section table.allergies-table th,
.allergies-section table.allergies-table th {
  font-weight: 600;
}

.emr-mz-dashboard .allergies-section table.allergies-table td.allergies-allergen-cell,
.allergies-section table.allergies-table td.allergies-allergen-cell {
  white-space: nowrap;
}

.emr-mz-dashboard .allergies-section .allergies-row-btn,
.allergies-section .allergies-row-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  max-width: 16px;
  max-height: 16px;
  padding: 0;
  margin: 0;
  line-height: 16px;
}

.emr-mz-dashboard .allergies-section table.allergies-table svg,
.emr-mz-dashboard .allergies-section .allergies-row-btn svg,
.allergies-section table.allergies-table svg,
.allergies-section .allergies-row-btn svg {
  width: 12px;
  height: 12px;
}

.emr-mz-dashboard .allergies-section .allergies-search,
.emr-mz-dashboard .allergies-section input.allergies-search:not([type]),
.emr-mz-dashboard .allergies-section input.allergies-search[type="search"]:not(.browser-default),
.emr-mz-dashboard .allergies-section input.allergies-search[type="search"],
.allergies-section .allergies-search {
  display: block !important;
  appearance: auto !important;
  -webkit-appearance: auto !important;
  box-sizing: border-box !important;
  height: 24px !important;
  min-height: 0 !important;
  max-height: 24px !important;
  margin: 0 !important;
  padding: 2px 8px 2px 28px !important;
  font-family: Arial, sans-serif !important;
  font-size: 16px !important;
  line-height: 16px !important;
}

.emr-mz-dashboard .allergies-section .allergies-control,
.emr-mz-dashboard .allergies-section input.allergies-control:not([type]),
.emr-mz-dashboard .allergies-section input.allergies-control[type="text"]:not(.browser-default),
.emr-mz-dashboard .allergies-section input.allergies-control[type="text"],
.emr-mz-dashboard .allergies-section input.allergies-control[type="date"]:not(.browser-default),
.emr-mz-dashboard .allergies-section input.allergies-control[type="date"],
.emr-mz-dashboard .allergies-section select.allergies-control:not(.browser-default),
.emr-mz-dashboard .allergies-section select.allergies-control,
.allergies-section .allergies-control {
  display: block !important;
  appearance: auto !important;
  -webkit-appearance: auto !important;
  box-sizing: border-box !important;
  height: 16px !important;
  min-height: 0 !important;
  max-height: 16px !important;
  width: 100%;
  margin: 0 !important;
  padding: 0 4px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border: 1px solid #e4d8c8 !important;
  border-radius: 2px !important;
  background: #fff !important;
  box-shadow: none !important;
  font-family: Arial, sans-serif !important;
  font-size: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
}

.emr-mz-dashboard .allergies-section input[type="checkbox"],
.emr-mz-dashboard .allergies-section input[type="checkbox"]:not(:checked),
.emr-mz-dashboard .allergies-section input[type="checkbox"]:checked,
.allergies-section input[type="checkbox"] {
  position: static !important;
  left: auto !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  visibility: visible !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  width: 16px !important;
  height: 16px !important;
  min-width: 16px !important;
  min-height: 16px !important;
  margin: 0 !important;
  z-index: auto !important;
}

.emr-mz-dashboard .allergies-section .allergies-toolbar-btn,
.allergies-section .allergies-toolbar-btn {
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-allergies.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;;EAEE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;;EAgBE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;;;EAIE,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;EAKE,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;;;;;;;;EASE,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,yCAAyC;EACzC,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;;;EAIE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,uCAAuC;EACvC,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["/*\n * Patient → Clinical → Allergies only.\n *\n * Materialize is prefixed to `.emr-mz-dashboard`. Without these scoped\n * counters, `td, th { padding: 15px 5px }`, 3rem inputs, `select { display:\n * none }`, and hidden native checkboxes inflate the allergy table and hide\n * form controls. Do not change global Materialize or Medical History.\n */\n\n.emr-mz-dashboard .allergies-section,\n.allergies-section {\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n  box-sizing: border-box;\n}\n\n.emr-mz-dashboard .allergies-section *,\n.emr-mz-dashboard .allergies-section *::before,\n.emr-mz-dashboard .allergies-section *::after,\n.allergies-section *,\n.allergies-section *::before,\n.allergies-section *::after {\n  box-sizing: border-box;\n}\n\n.emr-mz-dashboard .allergies-section,\n.allergies-section,\n.emr-mz-dashboard .allergies-section h2,\n.emr-mz-dashboard .allergies-section h3,\n.emr-mz-dashboard .allergies-section p,\n.emr-mz-dashboard .allergies-section li,\n.emr-mz-dashboard .allergies-section label,\n.emr-mz-dashboard .allergies-section span,\n.emr-mz-dashboard .allergies-section button,\n.allergies-section h2,\n.allergies-section h3,\n.allergies-section p,\n.allergies-section li,\n.allergies-section label,\n.allergies-section span,\n.allergies-section button {\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .allergies-section table.allergies-table,\n.allergies-section table.allergies-table {\n  display: table !important;\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  position: static;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .allergies-section table.allergies-table thead,\n.allergies-section table.allergies-table thead {\n  display: table-header-group !important;\n  float: none;\n  position: static;\n}\n\n.emr-mz-dashboard .allergies-section table.allergies-table tbody,\n.allergies-section table.allergies-table tbody {\n  display: table-row-group !important;\n  float: none;\n  position: static;\n}\n\n.emr-mz-dashboard .allergies-section table.allergies-table tr,\n.allergies-section table.allergies-table tr {\n  display: table-row !important;\n  height: 20px;\n}\n\n.emr-mz-dashboard .allergies-section table.allergies-table th,\n.emr-mz-dashboard .allergies-section table.allergies-table td,\n.allergies-section table.allergies-table th,\n.allergies-section table.allergies-table td {\n  display: table-cell !important;\n  height: 20px;\n  min-height: 20px;\n  max-height: 20px;\n  padding: 2px 2px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  line-height: 16px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0;\n  text-transform: none;\n  vertical-align: middle;\n  box-sizing: border-box;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.emr-mz-dashboard .allergies-section table.allergies-table th,\n.allergies-section table.allergies-table th {\n  font-weight: 600;\n}\n\n.emr-mz-dashboard .allergies-section table.allergies-table td.allergies-allergen-cell,\n.allergies-section table.allergies-table td.allergies-allergen-cell {\n  white-space: nowrap;\n}\n\n.emr-mz-dashboard .allergies-section .allergies-row-btn,\n.allergies-section .allergies-row-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  min-height: 16px;\n  max-width: 16px;\n  max-height: 16px;\n  padding: 0;\n  margin: 0;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .allergies-section table.allergies-table svg,\n.emr-mz-dashboard .allergies-section .allergies-row-btn svg,\n.allergies-section table.allergies-table svg,\n.allergies-section .allergies-row-btn svg {\n  width: 12px;\n  height: 12px;\n}\n\n.emr-mz-dashboard .allergies-section .allergies-search,\n.emr-mz-dashboard .allergies-section input.allergies-search:not([type]),\n.emr-mz-dashboard .allergies-section input.allergies-search[type=\"search\"]:not(.browser-default),\n.emr-mz-dashboard .allergies-section input.allergies-search[type=\"search\"],\n.allergies-section .allergies-search {\n  display: block !important;\n  appearance: auto !important;\n  -webkit-appearance: auto !important;\n  box-sizing: border-box !important;\n  height: 24px !important;\n  min-height: 0 !important;\n  max-height: 24px !important;\n  margin: 0 !important;\n  padding: 2px 8px 2px 28px !important;\n  font-family: Arial, sans-serif !important;\n  font-size: 16px !important;\n  line-height: 16px !important;\n}\n\n.emr-mz-dashboard .allergies-section .allergies-control,\n.emr-mz-dashboard .allergies-section input.allergies-control:not([type]),\n.emr-mz-dashboard .allergies-section input.allergies-control[type=\"text\"]:not(.browser-default),\n.emr-mz-dashboard .allergies-section input.allergies-control[type=\"text\"],\n.emr-mz-dashboard .allergies-section input.allergies-control[type=\"date\"]:not(.browser-default),\n.emr-mz-dashboard .allergies-section input.allergies-control[type=\"date\"],\n.emr-mz-dashboard .allergies-section select.allergies-control:not(.browser-default),\n.emr-mz-dashboard .allergies-section select.allergies-control,\n.allergies-section .allergies-control {\n  display: block !important;\n  appearance: auto !important;\n  -webkit-appearance: auto !important;\n  box-sizing: border-box !important;\n  height: 16px !important;\n  min-height: 0 !important;\n  max-height: 16px !important;\n  width: 100%;\n  margin: 0 !important;\n  padding: 0 4px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  border: 1px solid #e4d8c8 !important;\n  border-radius: 2px !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  font-family: Arial, sans-serif !important;\n  font-size: 16px !important;\n  line-height: 16px !important;\n  vertical-align: middle;\n}\n\n.emr-mz-dashboard .allergies-section input[type=\"checkbox\"],\n.emr-mz-dashboard .allergies-section input[type=\"checkbox\"]:not(:checked),\n.emr-mz-dashboard .allergies-section input[type=\"checkbox\"]:checked,\n.allergies-section input[type=\"checkbox\"] {\n  position: static !important;\n  left: auto !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  visibility: visible !important;\n  appearance: auto !important;\n  -webkit-appearance: checkbox !important;\n  width: 16px !important;\n  height: 16px !important;\n  min-width: 16px !important;\n  min-height: 16px !important;\n  margin: 0 !important;\n  z-index: auto !important;\n}\n\n.emr-mz-dashboard .allergies-section .allergies-toolbar-btn,\n.allergies-section .allergies-toolbar-btn {\n  height: 24px;\n  min-height: 24px;\n  max-height: 24px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
